import React, { useEffect, useMemo, useRef, useState } from 'react'
import { FeatherChevronDown, FeatherChevronUp } from '../../../../../components/common/Icons'
import { ASIA_SEOUL, COOKIE_OPT } from '../../../../../modules/vars'

import { CurrentUser } from '../../../../../model/Common/common.interface'
import { DATA_REF_KEY } from '../../../../../modules/ids/e2e/student'
import { STUDENT_BTN_ID } from '../../../../../modules/ids/gtm/student'
import EmptyBlock from '../../../../common/EmptyBlock'
import { IMG_NAVIGATION_RINGLE_LOGO } from '../../../constants/navigation.constant'
import { NAVIGATION_BAR_HREF_TYPE } from '../../../interface/navigation.interface'
/**
 * for Safari browser below 13.1
 * https://ringleplus.sentry.io/issues/3759888820/events/7370260621964a91be34541697b12a76/?project=6093896
 * https://stackoverflow.com/questions/65819296/unhandled-runtime-error-referenceerror-cant-find-variable-resizeobserver-on-s
 * https://github.com/nerdyman/react-compare-slider/issues/27
 */
import classNames from 'classnames'
import dynamic from 'next/dynamic'
import { useCookies } from 'react-cookie'
import { install } from 'resize-observer'
import { useEventGnbDate } from '../../../../../modules/apis/sanity'
import { useCurrentUser } from '../../../../../modules/context/UserContext'
import useAppRouter from '../../../../../modules/hooks/common/useAppRouter'
import { useShowChannelButton } from '../../../../../modules/hooks/common/useChannelIOSetup'
import useHandleLogout from '../../../../../modules/hooks/student/auth/useHandleLogout'
import { s_menu, s_signin } from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import urls from '../../../../../modules/urls'
import BandBannerContainer from '../../../../common/BandBannerContainer'
import { HEADER_NAVIGATION_BAR_ITEM_LIST, HEADER_NAVIGATION_RIGHT_BAR_ITEM_LIST } from '../../../data/navigation.data'
import { sendNavigationMenuClickEvent } from '../../../helpers/NavigationHelpers'
import LanguageList from '../LanguageList'

if (typeof window !== 'undefined') install()

const CookieBanner = dynamic(() => import('../../../../banner/CookieBanner'))

const DropdownMenu = (props: any) => {
  const { item, list, handleOnClickMenuBtn } = props
  const [showDropdown, setShowDropdown] = useState(false)
  const [selected, setSelected] = useState(null)

  return (
    <div className="relative">
      <button
        key={item.id}
        className="text-14 flex items-center font-medium leading-[160%]"
        style={{
          color: item.inActiveTextColor,
        }}
        onClick={() => setShowDropdown(!showDropdown)}
      >
        {item.title}
        {showDropdown ? <FeatherChevronUp /> : <FeatherChevronDown />}
      </button>
      <div className="absolute top-[-2px] right-10 h-[6px] w-[6px] rounded-full bg-red-500"></div>
      {showDropdown && (
        <div
          className={classNames('fixed z-[9999] rounded-[7px] bg-white p-[8px] ')}
          style={{ boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)' }}
        >
          {list.map((menu, i) => (
            <div
              key={menu.title}
              onClick={() => handleOnClickMenuBtn(menu.id, menu.title, menu.href, menu.type)}
              className="cursor-pointer py-[11px] px-[12px] text-[14px] font-medium text-black hover:bg-[#F8F8FB] hover:text-[#7C7F94] active:bg-purple-50 active:text-purple-500"
            >
              {menu.title}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
interface IHeaderNavigationBarV2Desktop {
  channelTalk?: boolean
  subNavTabClassName?: string
  subNavTab?: any
}

const HeaderNavigationBarV2Desktop = ({
  channelTalk = true,
  subNavTabClassName = '',
  subNavTab,
}: IHeaderNavigationBarV2Desktop) => {
  const router = useAppRouter()
  const containerRef = useRef<HTMLDivElement>(null)
  const handleLogout = useHandleLogout()
  const { t, isLocaleKO, locale, updateLandingLocale } = useTranslation()
  const { currentUser } = useCurrentUser()
  const promotionOn = false

  useShowChannelButton(channelTalk)

  const [cookies, setCookies] = useCookies(['is_close_cookie_banner'])

  const [containerHeight, setContainerHeight] = useState(60)

  const [isClient, setIsClient] = useState(false)

  const isLanding = useMemo(() => router.asPath.includes('/landing/'), [router.asPath])
  const isLandingHome = useMemo(() => router.asPath.includes(urls.oneOnOne.index), [router.asPath])

  const { data: eventGnbData } = useEventGnbDate()

  const handleClickLogo = () => {
    sendNavigationMenuClickEvent(STUDENT_BTN_ID.CLICK_HOME_RINGLE_LOGO, 'Ringle Logo', currentUser, router, null)

    if (isLandingHome) {
      router.reload()
    } else {
      router.push(urls.oneOnOne.index)
    }
  }

  const handleOnClickMenuBtn = (id: STUDENT_BTN_ID, title: string, href: string, type: NAVIGATION_BAR_HREF_TYPE) => {
    sendNavigationMenuClickEvent(id, title, currentUser, router, null)

    if (type === NAVIGATION_BAR_HREF_TYPE.OUTBOUND) {
      window.open(href, '_blank')
    } else {
      router.push(href)
    }
  }

  const handleOnClickSignInBtn = (_currentUser: CurrentUser) => {
    sendNavigationMenuClickEvent(
      _currentUser ? STUDENT_BTN_ID.CLICK_NAVIGATION_LOGOUT : STUDENT_BTN_ID.CLICK_NAVIGATION_LOGIN,
      _currentUser ? '로그아웃' : '로그인',
      currentUser,
      router,
      null
    )

    if (_currentUser) {
      handleLogout()
    } else {
      router.push(urls.student.auth.signIn)
    }
  }

  const handleOnClickSignUpBtn = () => {
    sendNavigationMenuClickEvent(STUDENT_BTN_ID.SIGN_UP, '회원가입', currentUser, router, null)

    router.push(urls.student.auth.new)
  }

  const handleOnClickMyClassBtn = () => {
    sendNavigationMenuClickEvent(STUDENT_BTN_ID.CLICK_NAVIGATION_MY_CLASS, '내 강의실', currentUser, router, null)

    router.push(urls.student.newPortal.home)
  }

  const handleCloseCookieBanner = (e: React.SyntheticEvent) => {
    e.preventDefault()
    setCookies('is_close_cookie_banner', true, COOKIE_OPT)
  }

  useEffect(() => {
    setIsClient(true)
  }, [])

  useEffect(() => {
    /**
     * <쿠키 배너 노출 기준>
     * 로그인 유저 : timezone이 한국이 아닐 경우 노출
     * 미로그인 유저: 언어가 영어이면 노출
     *
     * 위 케이스 외에는 쿠키 배너 노출하지 않도록  is_close_cookie_banner 쿠키에 저장
     * + close 버튼을 눌러서 쿠키배너를 닫은 경우에도 is_close_cookie_banner 쿠키에 저장
     */
    if ((currentUser && currentUser?.timezone === ASIA_SEOUL) || (!currentUser && isLocaleKO)) {
      setCookies('is_close_cookie_banner', true, COOKIE_OPT)
    }
  }, [currentUser?.timezone])

  useEffect(() => {
    const containerResizeObserver = new ResizeObserver((entries) => {
      if (entries.length > 0) {
        const element = entries[0]
        setContainerHeight(element.contentRect.height)
      }
    })

    if (containerRef && containerRef.current) {
      containerResizeObserver.observe(containerRef.current)
    }

    return () => containerResizeObserver.disconnect()
  }, [containerRef])

  return (
    <>
      {/* 드랍다운 메뉴가 안보이는 현상이 있어서 overflow-hidden 제거 */}
      <div ref={containerRef} className="fixed top-0 z-[1000] w-full backdrop-blur-[5px]">
        <BandBannerContainer />

        {/* Navigation Bar */}
        <div className="flex min-h-[60px] w-full items-center justify-center bg-[rgba(255,255,255,0.85)] py-[11px] px-[20px]">
          <div className="flex w-full max-w-[1080px] items-center justify-between px-[20px]">
            <div className="flex w-[83px] h-[28px] items-center justify-start">
              <button onClick={() => handleClickLogo()}>
                <img src={IMG_NAVIGATION_RINGLE_LOGO} alt="ringle-logo" className="w-[83px] h-[28px]" />
              </button>
            </div>
            {/* Center Menu Button List */}
            {isClient && (
              <div className="flex flex-1 justify-between lg:ml-[51px] lg:mr-[32px]">
                <div
                  className={classNames('flex items-center', {
                    ' space-x-[32px]': isLocaleKO,
                    ' space-x-[24px]': !isLocaleKO,
                  })}
                >
                  {HEADER_NAVIGATION_BAR_ITEM_LIST(!!currentUser, locale, promotionOn, eventGnbData)
                    .filter((item) => item.isVisible)
                    .map((item) => (
                      <HeaderNavigationBarItem key={item.id} item={item} handleOnClickMenuBtn={handleOnClickMenuBtn} />
                    ))}
                </div>
                <div
                  className={classNames('flex items-center', {
                    ' space-x-[32px]': isLocaleKO,
                    ' space-x-[24px]': !isLocaleKO,
                  })}
                >
                  {HEADER_NAVIGATION_RIGHT_BAR_ITEM_LIST(locale)
                    .filter((item) => item.isVisible)
                    .map((item) => (
                      <HeaderNavigationBarItem key={item.id} item={item} handleOnClickMenuBtn={handleOnClickMenuBtn} />
                    ))}
                </div>
              </div>
            )}
            {/* Right Menu Buttons */}
            <div className="flex items-center justify-end space-x-12 pr-16">
              {/* Language Section */}
              <LanguageList />
              <button
                className="text-14 min-w-[80px] rounded-[5px] border border-[#4130A4] bg-white py-8 text-center font-medium leading-[160%] text-[#4130A4]"
                onClick={() => handleOnClickSignInBtn(currentUser)}
                data-ref={currentUser ? DATA_REF_KEY.btn_signout : DATA_REF_KEY.nav_signin}
              >
                {currentUser ? t(s_menu.mypage.sign_out) : t(s_menu.landing.signin)}
              </button>
              {!currentUser && (
                <button
                  className="text-14 min-w-[80px] rounded-[5px] bg-[#4130A4] py-8 text-center font-medium leading-[160%] text-white"
                  onClick={() => handleOnClickSignUpBtn()}
                  data-ref={DATA_REF_KEY.nav_signup}
                >
                  {t(s_signin.sign_up)}
                </button>
              )}
              {currentUser && (
                <button
                  className="text-14 min-w-[80px] rounded-[5px] bg-[#4130A4] py-8 text-center font-medium leading-[160%] text-white"
                  onClick={() => handleOnClickMyClassBtn()}
                >
                  {t(s_menu.landing.portal)}
                </button>
              )}
            </div>
          </div>
        </div>
        <div className={subNavTabClassName}>{subNavTab}</div>
      </div>
      <EmptyBlock h={containerHeight} />
      {cookies.is_close_cookie_banner !== 'true' && isLanding && <CookieBanner handleClose={handleCloseCookieBanner} />}
    </>
  )
}

export default HeaderNavigationBarV2Desktop

const HeaderNavigationBarItem = ({ item, handleOnClickMenuBtn }) => {
  const router = useAppRouter()
  const [isPanelOpen, setIsPanelOpen] = useState(false)

  const handleOnClickDropdownBtn = () => {
    setIsPanelOpen((prev) => !prev)
  }
  return (
    <div className="relative">
      <button
        key={item.id}
        className="text-14 font-medium leading-[160%] whitespace-nowrap flex flex-row items-center gap-[4px]"
        style={{
          color: router.asPath.includes(item.href) ? item.activeTextColor : item.inActiveTextColor,
        }}
        onClick={() =>
          item.type === NAVIGATION_BAR_HREF_TYPE.DROPDOWN
            ? handleOnClickDropdownBtn()
            : handleOnClickMenuBtn(item.id, item.title, item.href, item.type)
        }
      >
        {item.title}
        {item.type === NAVIGATION_BAR_HREF_TYPE.DROPDOWN && (
          <>
            {isPanelOpen ? (
              <FeatherChevronUp className="text-gray-500" />
            ) : (
              <FeatherChevronDown className="text-gray-500" />
            )}
          </>
        )}
      </button>

      {item.type === NAVIGATION_BAR_HREF_TYPE.DROPDOWN && isPanelOpen && (
        <div className="absolute top-[28px] left-0 min-w-[135px] space-y-[4px] rounded-[7px] bg-white p-[8px] shadow-[0_2px_8px_8px_rgba(0,0,0,0.15)]">
          {item.dropdownList &&
            item.dropdownList.map((dropdownItem, index) => {
              return (
                <button
                  key={index}
                  className="Body2-14Md block w-full rounded-[4px] p-[12px] text-left hover:bg-purple-50 hover:text-purple-500"
                  onClick={() => router.push(dropdownItem.href)}
                >
                  {dropdownItem?.title}
                </button>
              )
            })}
        </div>
      )}
    </div>
  )
}
